export const telephonyProviders = {
  twilio: "twilio",
  plivo: "plivo",
  plivoInternational: "plivoInternational",
  retell: "retell",
};

export const telephonyFeatures = {
  callOutbound: "callOutbound",
  callInbound: "callInbound",
  powerDialer: "powerDialer",
  parallelDialer: "parallelDialer",
  callForwarding: "callForwarding",
  callRouting: "callRouting",
  coldTransfer: "coldTransfer",
  warmTransfer: "warmTransfer",
  voicemails: "voicemails",
  callRecording: "callRecording",
  callTranscript: "callTranscript",
  callSwap: "callSwap",
  purchasePhoneNumber: "purchasePhoneNumber",
  deletePhoneNumber: "deletePhoneNumber",
  callMute: "callMute",
  callHold: "callHold",
  callDialer: "callDialer",
  callNote: "callNote",
  voicemailDrop: "voicemailDrop",
};

export const telephonyDeviceRefreshInterval = 60 * 60 * 1000;
